import cartEL from "./cart.json";
import confirmationEL from "./confirmation.json";
import customerDetailsEL from "./customerDetails.json";
import glossaryEL from "./glossary.json";
import homeEL from "./home.json";
import summaryEL from "./summary.json";
import controlEL from "./control.json";
import addressEL from "./address.json";
import commonEL from "./common.json";
import validationEL from "./validation.json";
import footerEL from "./footer.json";
import headerEL from "./header.json";
import portinEL from "./portin.json";
import countdownEL from "./countdown.json";

export const ELcart = cartEL;
export const ELcontrol = controlEL;
export const ELconfirmation = confirmationEL;
export const ELcustomerDetails = customerDetailsEL;
export const ELhome = homeEL;
export const ELsummary = summaryEL;
export const ELglossary = glossaryEL;
export const ELaddress = addressEL;
export const ELcommon = commonEL;
export const ELvalidation = validationEL;
export const ELfooter = footerEL;
export const ELheader = headerEL;
export const ELportin = portinEL;
export const ELcountdown = countdownEL;
